module.exports = __webpack_public_path__ + "static/media/13.2e4ae848.jpg";